import { useMemo } from "react"
import { useDataStore } from "../../Data"
import type { DataStore } from "../../Data/Store"
import { NoteApi, type INoteAttachmentResponse } from "../../Types"
import type { ApiClient } from "../../Types/Generated/LogbookApi/ApiRuntime"

function upload(api: ApiClient, shipId: number, attachment: File): Promise<INoteAttachmentResponse> {
  return new NoteApi(api).noteAttachments.create({
    params: { shipId, noteId: 0 },
    body: { attachment },
  }).call();
}

export function uploadShipAttachmentWithStore(
  store: DataStore,
  shipId: number,
  attachment: File,
): Promise<INoteAttachmentResponse> {
  return store.mutate({
    request: (client) => upload(client, shipId, attachment),
    reconcile: (response) => ({
      entities: { NoteAttachment: response.attachment ? [response.attachment] : [] },
    }),
  });
}

export function useShipAttachmentUploader(shipId: number) {
  const store = useDataStore();
  return useMemo(
    () => (attachment: File) => uploadShipAttachmentWithStore(store, shipId, attachment),
    [shipId, store],
  );
}
